// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import {fixtureSetItem, fixtureAddItem} from '../../actions/fixtureActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/fixture/FixtureAddEditForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants, fixtureConstants} from "../../constants";
import {reset} from "redux-form";


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.fixture.targetItem,
        userValue: state.app.currentUser
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getItem: (id) => {
        dispatch(getItem(id));
    },

    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        if(value.mode === 'edit')
            dispatch(edit(value));
        else
            dispatch(add(value));
    },

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const add = (values,mode) => {
    return (dispatch, getState) => {
        let formData = {
            'title'       : values.title,
            'description' : values.description
        };
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.post('fixture', formData).then(res => {
            dispatch(fixtureAddItem(res.data));
            if(res.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                dispatch(reset('addFixture'));
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const edit = (values) => {
    let id = values._id;

    return (dispatch, getState) => {
        let formData = {
            'title'       : values.title,
            'description' : values.description
        };
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('fixture/'+id, formData).then(editRes => {
            dispatch(fixtureSetItem(editRes.data));
            if(editRes.data.status === true) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ویرایش'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const getItem = (id) => {
    return (dispatch, getState) => {
        API_FETCH.get('fixture/'+id).then(fixtureInfo => {
            dispatch(fixtureSetItem(fixtureInfo.data.result));
        }).catch(error => {
            console.log(error);
        });
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
